import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'

const StatTable = ({ columns, rows, className = 'mui-table-format' }) => {
  return(
  <Table className={className}>
    <TableHead>
      <TableRow>
          {columns?.length > 0 && columns.map((col) => (
          <TableCell sx={{padding:'5px 5px !important'}} key={col.key || col.field}>{col.label}</TableCell>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>
        {rows?.length > 0 && rows.map((row, index) => (
        <TableRow key={index}>
            {columns?.length > 0 && columns.map((col) => (
            <TableCell sx={{padding:'5px 5px !important'}} key={col.key || col.field}>{col.render ? col.render(row) : row[col?.key || col?.field] }</TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  </Table>
)}

export default StatTable
